'use client';
import React, { useState } from 'react';
import { Calendar, ChevronDown } from 'lucide-react';

const ranges = ['Last 7 days', 'Last 30 days', 'Last 90 days', 'This year', 'Custom range'];

export default function DateRangeSelector() {
  const [selected, setSelected] = useState('Last 30 days');
  const [open, setOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className="btn-secondary text-sm flex items-center gap-2"
      >
        <Calendar size={14} />
        {selected}
        <ChevronDown size={13} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 z-50 card-surface border border-border shadow-lg w-48 py-1 rounded">
          {ranges?.map((range) => (
            <button
              key={`range-${range}`}
              onClick={() => { setSelected(range); setOpen(false); }}
              className={`w-full text-left px-4 py-2 text-sm transition-colors ${
                selected === range
                  ? 'bg-primary/10 text-primary font-semibold' :'hover:bg-muted text-foreground'
              }`}
            >
              {range}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}